/* eslint-disable */

const InfoIconProcessExcell = () => {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        background: "rgba(16,16,16,0.22)",
        borderRadius: 6,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <span
        style={{
          color: "white",
          fontSize: 14,
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        i
      </span>
    </div>
  );
};

export default InfoIconProcessExcell;
